import { retrieveData, formatCSVData } from "../../../../csv/JSONtoCSV";
import Papa from "papaparse";

export default async function handleDownloadCSV(checkboxStates ) {
  // const csvData = JSON.parse(
  //   localStorage.getItem("UpdatedDataArray")
  // );
  // Check if the 'selectCSVInputData' checkbox is selected
  if (checkboxStates.selectCSVInputData) {
    // Generate the CSV content
    // const csvContent = generateCSVData(csvData);
    
      const csvData = await retrieveData();
  
      const formattedCSVData = await formatCSVData(csvData);
      const csvContent = Papa.unparse(formattedCSVData);
     
  
    // Create a Blob (Binary Large Object) from the CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });

    // Create a download link and trigger the download
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);

    a.download = localStorage.getItem("initialFileName")+"-input-data.csv";

    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Clean up any resources (not always necessary)
    URL.revokeObjectURL(a.href);
  }
}
